// Client-side helpers to convert a File → data URL, so images can be
// uploaded from the browser without a separate storage service.

export function fileToDataUrl(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(file);
    });
}

// Resize+compress an image file so it fits within maxWidth (default 800px)
// and stays under a rough size budget. Returns a data URL (image/jpeg).
export async function compressImage(file, { maxWidth = 800, quality = 0.85 } = {}) {
    if (!file.type.startsWith("image/")) return fileToDataUrl(file);
    const dataUrl = await fileToDataUrl(file);
    return new Promise((resolve) => {
        const img = new Image();
        img.onload = () => {
            const scale = Math.min(1, maxWidth / img.width);
            const w = Math.round(img.width * scale);
            const h = Math.round(img.height * scale);
            const canvas = document.createElement("canvas");
            canvas.width = w;
            canvas.height = h;
            const ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0, w, h);
            // PNG for transparent logos, JPEG otherwise
            const type = file.type === "image/png" ? "image/png" : "image/jpeg";
            const out = canvas.toDataURL(type, quality);
            resolve(out);
        };
        img.onerror = () => resolve(dataUrl);
        img.src = dataUrl;
    });
}
